import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'a-radio',
  templateUrl: 'a-radio.component.html',
  styleUrls: ['a-radio.component.scss'],
})
export class ARadioComponent {

  @Input() name: any = 'rad';
  @Input() items: any = [];
  @Input() control: FormControl =  new FormControl();
  @Input() isSubmitted = true;
  @Output() onBlur = new EventEmitter<any>();

  constructor() {
  }

  onChange(e: any) {
    const value = e.target.value === 'true' || e.target.value === 'false' ? e.target.value === 'true' : e.target.value;
    console.log("VALEU", value)
    this.control.setValue(value);
    this.onBlur.emit();
  }

  onRadioClick(value: any) {
  if (this.control.value === value) {
    // Clicked the already selected radio → clear selection
    this.control.setValue(null);
    // Prevent the (change) event from setting it again
    this.onChange({ target: { value: null } });
  }
}
}
